export const minimalFontOnlyToolbarButtons = {
    moreParagraph: {},
    moreText: {
        buttons: ["bold", "italic", "underline", "strikeThrough", "subscript", "superscript", "textColor"],
        buttonsVisible: 7,
    },
    moreMisc: {},
    code: {},
};
